import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CompaniesStore } from './companies.store';
import { AppConfigQuery } from '../../../../core/state/app-config/app-config.query';
import { tap } from 'rxjs/operators';
import { Company } from './company.model';

@Injectable({ providedIn: 'root' })
export class CompaniesService {
    constructor(
        private _companiesStore: CompaniesStore,
        private appConfig: AppConfigQuery,
        private _http: HttpClient
    ) {}

    get() {
        return this._http.get<Array<Company>>('assets/company-info/data.json').pipe(
            tap((entities) => {
                this._companiesStore.set(entities);
            })
        );
    }
}
